import { useState } from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { Trash } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import ConfirmDeleteModal from '@/screens/users/components/ConfirmDeleteModal/confirmDeleteModal';
import { Button as ButtonShad } from '@/components/ui/button';
const InputPhoneDelete = ({
  name,
  label = null,
  placeholder,
  className,
  isRequired = false,
  isDisabled = false,
  canPhone = false,
  defaultCountry,
}) => {
  const {
    control,
    setValue,
    formState: { errors },
  } = useFormContext();
  const { t } = useTranslation('translation', { keyPrefix: 'inputs' });
  const [modalOpen, setModalOpen] = useState(false);

  const handleDelete = () => setModalOpen(true);

  const confirmDelete = () => {
    setValue(name, '');
  };

  return (
    <div className={className}>
      {label && (
        <label htmlFor={name} className='tw-block tw-text-sm tw-font-medium tw-mb-2 mb-2'>
          {label}
        </label>
      )}

      <Controller
        name={name}
        control={control}
        defaultValue=''
        rules={{
          required: isRequired ? t('required') : false,
        }}
        render={({ field }) => {
          const hasValue = !!field.value;

          return (
            <div className='tw-relative tw-w-full '>
              <PhoneInput
                {...field}
                id={name}
                defaultCountry={defaultCountry}
                international
                placeholder={placeholder}
                numberInputProps={{
                  className: `inputdelete phone-input-style ${
                    errors[name] ? 'phone-input-error' : ''
                  }`,
                }}
                className='tw-w-full'
                disabled={isDisabled}
              />
              {canPhone && hasValue && (
                <ButtonShad
                  size='icon'
                  variant='ghost'
                  type='button'
                  className='tw-absolute tw-right-1 tw-top-1 tw-h-8 tw-w-8'
                  onClick={handleDelete}
                >
                  <Trash className='tw-h-4 tw-w-4' />
                </ButtonShad>
              )}

              {errors[name] && (
                <p className='tw-mt-1 tw-text-xs tw-text-red-500'>{errors[name].message}</p>
              )}

              <ConfirmDeleteModal
                open={modalOpen}
                onClose={() => setModalOpen(false)}
                onConfirm={confirmDelete}
                title={t('confirmDeletePhone')}
                message={t('confirmDeletePhoneMessage')}
              />
            </div>
          );
        }}
      />
    </div>
  );
};

export default InputPhoneDelete;
